module.exports = __webpack_public_path__ + "img/1x.4006c7f.jpg";